import { render, staticRenderFns } from "./CascaderItem.vue?vue&type=template&id=221c2a1c&scoped=true"
import script from "./CascaderItem.vue?vue&type=script&lang=js"
export * from "./CascaderItem.vue?vue&type=script&lang=js"
import style0 from "./CascaderItem.vue?vue&type=style&index=0&id=221c2a1c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221c2a1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('221c2a1c')) {
      api.createRecord('221c2a1c', component.options)
    } else {
      api.reload('221c2a1c', component.options)
    }
    module.hot.accept("./CascaderItem.vue?vue&type=template&id=221c2a1c&scoped=true", function () {
      api.rerender('221c2a1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/CascaderItem.vue"
export default component.exports